module.exports = __webpack_public_path__ + "static/media/poster-488.89fe5615.png";